import { isModelConceptRelationship } from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link Project} add missing entries to `modelsByIri`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v37 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v37Projects(prevState.projects);
  }

  return nextState;
};

const v37Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const modelsByIri = { ...project.diagram.model.modelData.modelsByIri };
    const addProjectModelIdsToIri = (iri: string) => {
      if (!modelsByIri[iri]?.length) {
        modelsByIri[iri] = [project.targetModelId];
      }
    };

    Object.values(project.diagram.model.modelData.attributesByIri).forEach(
      (data) => {
        Object.values(data.domains).forEach((data) => {
          addProjectModelIdsToIri(data.value);
        });
        Object.values(data.ranges).forEach((data) => {
          addProjectModelIdsToIri(data.value);
        });
        addProjectModelIdsToIri(data.value);
      }
    );

    project.diagram.model.linkDataArray.forEach((data) => {
      if (isModelConceptRelationship(data)) {
        const conceptRelationship = data;
        addProjectModelIdsToIri(conceptRelationship.value);
      }
    });

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            modelsByIri,
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
